import React from 'react'

const EmailIcon = () => {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33341 14.1663C1.87508 14.1663 1.48286 14.0033 1.15675 13.6772C0.830081 13.3505 0.666748 12.958 0.666748 12.4997V2.49967C0.666748 2.04134 0.830081 1.64912 1.15675 1.32301C1.48286 0.996341 1.87508 0.833008 2.33341 0.833008H15.6667C16.1251 0.833008 16.5176 0.996341 16.8442 1.32301C17.1704 1.64912 17.3334 2.04134 17.3334 2.49967V12.4997C17.3334 12.958 17.1704 13.3505 16.8442 13.6772C16.5176 14.0033 16.1251 14.1663 15.6667 14.1663H2.33341ZM9.00008 8.33301L2.33341 4.16634V12.4997H15.6667V4.16634L9.00008 8.33301ZM9.00008 6.66634L15.6667 2.49967H2.33341L9.00008 6.66634ZM2.33341 4.16634V2.49967V12.4997V4.16634Z"
        fill="#999FAC"
      />
    </svg>
  )
}

export default EmailIcon
